const getImageOrFallback = (url, fallback) => new Promise((resolve, reject) => {
    const img = new window.Image();
    img.src = url;
    img.onload = () => resolve({ imgSrc: url, naturalWidth: img.naturalWidth, naturalHeight: img.naturalHeight });
    img.onerror = () => reject(url);
}).catch(() => ({ imgSrc: fallback }));

export default getImageOrFallback;
